import React from "react";
import { JSONTree } from "react-json-tree";
import PropTypes from "prop-types";
import { prettyPrintJSON } from "./helper";
import styles from "./jsonViewer.module.less";
import classNames from "classnames";
import { getArrowContainerStyle, getArrowStyle, getItemString, getNestedLabelStyle, getValueLabelStyle, labelRenderer, theme, valueRenderer } from "./JsonViewerThemeAndStyling";
function JsonPreview(_ref) {
  let {
    data,
    hideRoot,
    collectionLimit,
    initiallyExpandedLevel,
    previewContainerClassName,
    rootLabel,
    getItemString,
    getValueRenderer,
    getlLabelRenderer
  } = _ref;
  const parsedData = React.useMemo(() => prettyPrintJSON(data), [data]);
  const viewerContainerClasses = classNames({
    [styles["viewer-container"]]: true,
    [previewContainerClassName]: !!previewContainerClassName
  });
  const shouldExpandNodeInitially = (keyPath, value, layer) => {
    return layer < initiallyExpandedLevel;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !parsedData?.error && /*#__PURE__*/React.createElement("div", {
    className: viewerContainerClasses
  }, /*#__PURE__*/React.createElement(JSONTree, {
    data: parsedData?.data,
    hideRoot: hideRoot,
    collectionLimit: collectionLimit,
    keyPath: [`${rootLabel}`],
    shouldExpandNodeInitially: shouldExpandNodeInitially,
    theme: {
      extend: theme,
      nestedNodeLabel: getNestedLabelStyle,
      valueLabel: getValueLabelStyle,
      arrow: getArrowStyle,
      arrowContainer: getArrowContainerStyle
    },
    getItemString: getItemString,
    valueRenderer: getValueRenderer,
    labelRenderer: getlLabelRenderer
  })));
}
JsonPreview.defaultProps = {
  hideRoot: false,
  data: {},
  collectionLimit: 1,
  initiallyExpandedLevel: 1,
  rootLabel: "Object",
  getItemString: getItemString,
  getlLabelRenderer: labelRenderer,
  getValueRenderer: valueRenderer
};
JsonPreview.propTypes = {
  data: PropTypes.string,
  initiallyExpandedLevel: PropTypes.number,
  hideRoot: PropTypes.bool,
  collectionLimit: PropTypes.number,
  previewContainerClassName: PropTypes.object,
  rootLabel: PropTypes.string,
  getItemString: PropTypes.func,
  getValueRenderer: PropTypes.func,
  getlLabelRenderer: PropTypes.func
};
export { JsonPreview };